import "./App.css";
import MainPage from "./Components/MainPage";

function App() {
  return (
    <div className="App">
      <MainPage />
      <div id="footer">
        <div>
          <h4>Designed by Amit Sarah Pal with love</h4>
        </div>
      </div>
    </div>
  );
}

export default App;
